import { render, staticRenderFns } from "./UserMasterEdit.vue?vue&type=template&id=6c4e7b8a"
import script from "./UserMasterEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserMasterEdit.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports